import React, { useState } from 'react';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Divider,
    Box
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Add, Remove } from '@mui/icons-material';
import { CrossCircleIcon } from '../../../assets';


const useStyles = makeStyles((theme) => ({
    accordionSummary: {
        justifyContent: 'space-between',
    },
}));

const CustomAccordion = (props) => {
    const { title,
        component,
        accordionContainerBackground,
        accordionTitleColor,
        acoordianDetailsBackground,
        isIconEnable,
        handleClick,
        byDefaultOpen,
        acoordianDetailsPadding,
        iconColor,
    } = props;
    const classes = useStyles();
    const [expanded, setExpanded] = useState(byDefaultOpen);

    const handleAccordionToggle = () => {
        setExpanded(!expanded);
    };
    return (
        <Accordion expanded={expanded}
             onChange={handleAccordionToggle} className={`${accordionContainerBackground} custom-accordion`}
             >
            <AccordionSummary
                expandIcon={
                    <Box className="flex-row-center margin-10px">
                        {expanded ? <Remove sx={{ color: iconColor }} fontSize='1rem' /> : <Add sx={{ color: iconColor }} fontSize='1rem' />}
                    </Box>
                }
                className={classes.accordionSummary}
            >
                <Box className="flex-row gap-16">
                    <Typography className={`text-md-bold ${accordionTitleColor}`}
                    >
                        {title}
                    </Typography>
                    {isIconEnable && <Box onClick={()=> handleClick(title)}> <img src={CrossCircleIcon} className='icon'/> </Box>}
                </Box>
            </AccordionSummary>
            <Divider />
            <AccordionDetails 
                className={`flex-column gap-24 ${acoordianDetailsBackground} ${acoordianDetailsPadding}`}>
                {component}
            </AccordionDetails>
        </Accordion>
    );
};

CustomAccordion.defaultProps = {
    accordionContainerBackground: 'bg-gray-50',
    accordionTitleColor: 'gray-900',
    acoordianDetailsBackground: 'bg-gray-50',
    isIconEnable: false,
    handleClick: () => {},
    byDefaultOpen: false,
    acoordianDetailsPadding:'padding-t-8',
    iconColor:'#AE5DA5',
};

export default CustomAccordion;
